import { ElementType, HTMLAttributes, ReactNode } from "react";
import { cx } from "./classNames";

type CardTone = "soft" | "strong" | "accent" | "ink";

const toneClassMap: Record<CardTone, string> = {
  soft: "bg-white/55 border border-black/5 shadow-brand-shadow",
  strong: "bg-brand-surface-strong border border-black/8 shadow-brand-shadow",
  accent:
    "bg-[linear-gradient(160deg,rgba(255,255,255,0.98),rgba(230,239,236,0.88))] border border-brand-highlight/30 shadow-brand-shadow",
  ink: "bg-brand-ink text-white border border-black/5 shadow-brand-shadow",
};

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  tone?: CardTone;
  padding?: "sm" | "md" | "lg";
  animated?: boolean;
  children: ReactNode;
}

export function Card({
  as: Tag = "section",
  tone = "soft",
  padding = "md",
  animated = true,
  className,
  children,
  ...props
}: CardProps) {
  const paddingClass = padding === "sm" ? "p-4" : padding === "lg" ? "p-8" : "p-6";

  return (
    <Tag
      className={cx(
        "rounded-[1.5rem]",
        animated && "motion-fade-up",
        toneClassMap[tone],
        paddingClass,
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}
